__turbopack_context__.v({
  "card": "_6-AeBq_card",
  "card-content-container": "_6-AeBq_card-content-container",
  "card-header": "_6-AeBq_card-header",
  "fully-boxed": "_6-AeBq_fully-boxed",
  "img-skeleton": "_6-AeBq_img-skeleton",
  "line": "_6-AeBq_line",
  "location": "_6-AeBq_location",
  "personal-proposal": "_6-AeBq_personal-proposal",
  "price": "_6-AeBq_price",
  "price-explanation": "_6-AeBq_price-explanation",
  "producer-image": "_6-AeBq_producer-image",
  "promo": "_6-AeBq_promo",
  "section-header": "_6-AeBq_section-header",
  "section-title": "_6-AeBq_section-title",
  "selected-producer": "_6-AeBq_selected-producer",
  "selected-producer-name": "_6-AeBq_selected-producer-name",
  "simulation": "_6-AeBq_simulation",
  "skeleton": "_6-AeBq_skeleton",
  "skeleton-loading": "_6-AeBq_skeleton-loading",
  "tag": "_6-AeBq_tag",
  "usage": "_6-AeBq_usage",
  "usage-badge": "_6-AeBq_usage-badge",
  "usage-badges": "_6-AeBq_usage-badges",
});
